<template>
  <div class="w-full">
    <!-- Cabecera -->
    <div class="bg-white p-4 h-[68px] rounded-lg shadow-md">
      <!-- Estructura original para pantallas grandes -->
      <div class="hidden sm:flex flex-wrap mb-4">
        <div class="flex flex-1 items-center">
          <fwb-heading tag="h2" class="text-style-xl">Detalle de reporte</fwb-heading>
        </div>
        <div class="flex flex-1 justify-end items-center">
          <fwb-breadcrumb>
            <fwb-breadcrumb-item href="/reports/list" class="custom-alert-text">
              Reportes
            </fwb-breadcrumb-item>
            <fwb-breadcrumb-item class="custom-alert-text">
              Detalle #{{ $route.params.id }}
            </fwb-breadcrumb-item>
          </fwb-breadcrumb>
        </div>
      </div>

      <!-- Estructura para móviles -->
      <div class="sm:hidden flex items-center h-full gap-2">
        <div class="flex-1 min-w-0 overflow-hidden custom-alert-text h-full">
          <fwb-breadcrumb>
            <fwb-breadcrumb-item href="/reports/list" class="custom-alert-text">
              Lista de reportes
            </fwb-breadcrumb-item>
            <fwb-breadcrumb-item class="custom-alert-text">
              Detalle del reporte {{ $route.params.id }}
            </fwb-breadcrumb-item>
          </fwb-breadcrumb>
        </div>
      </div>
    </div>
    
    <!-- Contenedor para el formulario -->
    <div class="mx-auto p-4 px-0">
      <div class="flex flex-wrap">
        <div class="w-full rounded overflow-hidden shadow-lg bg-white p-6 px-3">
          <Loader :loading="isLoading" />
          <ReadReportComponent 
            v-if="currentReport && !isLoading"
            :visible="true" 
            :report="currentReport"
            @close="handleClose"
          />
          <div v-else-if="!isLoading" class="text-center text-gray-500">
            No se encontró el reporte
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { FwbBreadcrumb, FwbBreadcrumbItem, FwbHeading } from 'flowbite-vue';
import { ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ReadReportComponent from '@/components/reports/ReadReportComponent.vue';
import axios from 'axios';
import { useStore } from 'vuex';
import Loader from '@/components/loaderComponent.vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const currentReport = ref(null);
const isLoading = ref(false);

// Cargar datos del reporte basado en el ID de la ruta
const loadReportData = async () => {
  if (!route.params.id) {
    router.push('/reports/list');
    return;
  }

  try {
    isLoading.value = true;
    const session = store.getters.getUserSession;
    
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/reports/${route.params.id}`,
      {
        headers: { 
          Authorization: `Bearer ${session.token_api}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (response.status === 200) {
      currentReport.value = response.data.resp || response.data;
    }
  } catch (error) {
    console.error('Error loading report:', error);
    router.push('/reports/list');
  } finally {
    isLoading.value = false;
  }
};

const handleClose = () => {
  router.push('/reports/list');
};

// Cargar datos cuando cambie el parámetro de la ruta
watch(() => route.params.id, (newId) => {
  if (newId) {
    loadReportData();
  }
});

// Cargar datos al montar el componente
onMounted(() => {
  if (route.params.id) {
    loadReportData();
  } else {
    router.push('/reports/list');
  }
});
</script>

<style scoped>
/* Estos estilos solo se aplicarán en móvil */
@media (max-width: 639px) {
  .custom-alert-text {
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .text-style-xl {
    font-size: 1rem;
    line-height: 1rem;
  }
}
</style>